import React from "react";
import { Form } from "react-bootstrap";

export const AutoCompleteValue = "off"; //new-password for chrome

// `value ?? ""` keeps the field controlled for its whole lifetime. Pages seed
// state with null and fill it from the API later; without this the input starts
// uncontrolled and React warns when the value arrives. `??` (not `||`) so a
// legitimate 0 still renders.
const InputForm = ({
  value,
  placeholder,
  isDisabled = false,
  textArea = false,
  onChange = null,
  rows = 2,
  type = "text",
  maxlength = null,
  ...rest
}) => {
  return (
    <>
      {textArea ? (
        <Form.Control
          placeholder={placeholder}
          value={value ?? ""}
          disabled={isDisabled}
          onChange={onChange}
          as="textarea"
          rows={rows}
          type={type}
          maxLength={maxlength}
          {...rest}
        />
      ) : (
        <Form.Control
          placeholder={placeholder}
          value={value ?? ""}
          autoComplete={AutoCompleteValue}
          disabled={isDisabled}
          onChange={onChange}
          type={type}
          maxLength={maxlength}
          {...rest}
        />
      )}
    </>
  );
};

export default InputForm;
